import {Tooltip} from 'platform/components';
import {Box, Image} from 'platform/foundation';

import {forwardRef} from 'react';

import {defaultTo, pipe} from 'ramda';
import {floor} from 'ramda-adjunct';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRenderer, ICellRendererParams} from '../../types/AgGridTypes';

export interface ThumbnailCellRendererProps extends ICellRendererParams {}

const DEFAULT_ROW_HEIGHT = 30;
const BORDER_HEIGHT = 2;

function ThumbnailCellRendererComponent(
  {getValue, value, node, data}: ThumbnailCellRendererProps,
  _ref: React.Ref<ICellRenderer>
) {
  const imageSrc = getValue ? getValue() : value;
  const imageHeight = getImageHeight(node.rowHeight);

  const tooltipProps = useTooltipProps(data, node);

  if (!imageSrc) {
    return null;
  }

  return (
    <Box
      css={{
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        height: '80%',
        '& > span': {
          height: '100%',
        },
        img: {
          height: '100%',
          borderRadius: 'base',
        },
      }}
    >
      <Tooltip
        {...tooltipProps}
        isDisabled={false}
        label={<Image fit="contain" src={`${imageSrc}&height=500`} />}
      >
        <Image fit="contain" src={`${imageSrc}&height=${imageHeight}`} />
      </Tooltip>
    </Box>
  );
}

// We always need to subtract the border height from the row height to get the correct height for the image
const getImageHeight = pipe(
  defaultTo(DEFAULT_ROW_HEIGHT),
  floor,
  (height) => height - BORDER_HEIGHT
);

export const ThumbnailCellRenderer = forwardRef<ICellRenderer, ThumbnailCellRendererProps>(
  ThumbnailCellRendererComponent
);
